import React from 'react';

const FilterSection = ({ 
  selectedCategory,
  setSelectedCategory,
  categories,
  priceRange,
  setPriceRange,
  sortBy,
  setSortBy,
  ratingFilter,
  setRatingFilter,
  mockBooks
}) => {
  const priceRanges = [
    { name: 'Under $10', min: 0, max: 10, count: mockBooks.filter(book => book.price < 10).length },
    { name: '$10 - $15', min: 10, max: 15, count: mockBooks.filter(book => book.price >= 10 && book.price < 15).length },
    { name: '$15 - $20', min: 15, max: 20, count: mockBooks.filter(book => book.price >= 15 && book.price < 20).length },
    { name: 'Over $20', min: 20, max: Infinity, count: mockBooks.filter(book => book.price >= 20).length }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Filters</h2>
      
      {/* Price Range Filter */}
      <div className="mb-6">
        <h3 className="font-semibold mb-3 text-gray-700">Price Range</h3>
        <div className="space-y-2">
          {priceRanges.map((range) => (
            <label key={range.name} className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                name="priceRange"
                checked={priceRange?.name === range.name}
                onChange={() => setPriceRange(range)}
                className="form-radio text-purple-600 focus:ring-purple-500"
              />
              <span className="text-gray-600">
                {range.name} ({range.count} books)
              </span>
            </label>
          ))}
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="radio"
              name="priceRange"
              checked={!priceRange}
              onChange={() => setPriceRange(null)}
              className="form-radio text-purple-600 focus:ring-purple-500"
            />
            <span className="text-gray-600">All Prices</span>
          </label>
        </div>
      </div>

      {/* Rating Filter */}
      <div className="mb-6">
        <h3 className="font-semibold mb-3 text-gray-700">Minimum Rating</h3>
        <select
          value={ratingFilter}
          onChange={(e) => setRatingFilter(Number(e.target.value))}
          className="w-full rounded-lg border-gray-300 focus:ring-purple-500 focus:border-purple-500"
        >
          <option value={0}>All Ratings</option>
          <option value={4.5}>4.5+ ⭐</option>
          <option value={4}>4.0+ ⭐</option>
          <option value={3.5}>3.5+ ⭐</option>
        </select>
      </div>

      {/* Sort Options */}
      <div className="mb-6">
        <h3 className="font-semibold mb-3 text-gray-700">Sort By</h3>
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="w-full rounded-lg border-gray-300 focus:ring-purple-500 focus:border-purple-500"
        >
          <option value="rating">Highest Rated</option>
          <option value="reviews">Most Reviewed</option>
          <option value="priceAsc">Price: Low to High</option>
          <option value="priceDesc">Price: High to Low</option>
          <option value="titleAsc">Title: A to Z</option>
          <option value="titleDesc">Title: Z to A</option>
        </select>
      </div>

      {/* Clear Filters Button */}
      <button
        onClick={() => {
          setPriceRange(null);
          setRatingFilter(0);
          setSortBy('rating');
          setSelectedCategory('All');
        }}
        className="w-full py-2 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-lg transition-colors duration-200"
      >
        Clear All Filters
      </button>
    </div>
  );
};

export default FilterSection;
